import { useState } from 'react'

/**
 * useJobDrawers - Shared hook for managing JobMapDrawer and JobPreviewDrawer state
 *
 * Used by both MultipleJobsSection (Step 2) and PreviewMergeSection (Step 3)
 * to coordinate opening/closing drawers and transitioning between them.
 *
 * @returns {Object} Drawer state and handlers
 */
export const useJobDrawers = () => {
  const [isMapDrawerOpen, setIsMapDrawerOpen] = useState(false)
  const [isDetailsDrawerOpen, setIsDetailsDrawerOpen] = useState(false)
  const [selectedJobs, setSelectedJobs] = useState(null)
  const [selectedTargetJobId, setSelectedTargetJobId] = useState(null)

  const handleOpenMapDrawer = () => {
    setSelectedJobs(null)
    setIsMapDrawerOpen(true)
  }

  const handleCloseMapDrawer = () => {
    setIsMapDrawerOpen(false)
    setSelectedJobs(null)
  }

  const handleViewDetails = targetJobId => {
    setSelectedTargetJobId(targetJobId)
    setIsDetailsDrawerOpen(true)
  }

  const handleCloseDetailsDrawer = () => {
    setIsDetailsDrawerOpen(false)
    setSelectedTargetJobId(null)
  }

  const handleEditMapping = (sourceJobIds, targetJobId) => {
    setIsDetailsDrawerOpen(false)
    setSelectedTargetJobId(null)
    setSelectedJobs({ sourceJobIds, targetJobId })
    setIsMapDrawerOpen(true)
  }

  return {
    isMapDrawerOpen,
    isDetailsDrawerOpen,
    selectedJobs,
    selectedTargetJobId,
    handleOpenMapDrawer,
    handleCloseMapDrawer,
    handleViewDetails,
    handleCloseDetailsDrawer,
    handleEditMapping,
  }
}
